import { render, staticRenderFns } from "./NormalCover.vue?vue&type=template&id=d0541fe2&scoped=true&"
import script from "./NormalCover.vue?vue&type=script&lang=js&"
export * from "./NormalCover.vue?vue&type=script&lang=js&"
import style0 from "./NormalCover.vue?vue&type=style&index=0&id=d0541fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0541fe2",
  null
  
)

export default component.exports